import React from 'react';
import Markdown from 'utils/markdownToComponent';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';
import { colors } from 'styles';
import { breakpoint } from 'utils/mediaQueries';
import BlockButtonClientCases from 'components/ButtonClientCase/BlockButtonClientCases';

const ContentText = styled(Grid)`
  width: 100%;
  position: relative;
  text-align: center;
  margin-top: 3rem;
`;
const StyledMarkdown = styled(Markdown)`
  color: ${colors.purple};
  padding: 0 1rem;
  font-family: ${props => `${props.theme.typography.fontFamily}`};
  font-weight: normal;
  line-height: 2rem;
  width: 100%;
  ${breakpoint.down('lg')`
  font-size: ${props => `${props.theme.typography.body1.fontSize}
px`};`};
  ${breakpoint.down('xs')`
 font-size: ${props => `${props.theme.typography.body2.fontSize}
px`};`};
`;
const BlockBook = ({ body, lang }) => {
  return (
    <Grid
      container
      item
      xs={'auto'}
      sm={8}
      md={8}
      lg={10}
      justify="center"
      alignItems="center"
    >
      <ContentText
        container
        alignItems="center"
        justify="center"
        direction="column"
      >
        <StyledMarkdown variant="h6">{body.rawMarkdownBody}</StyledMarkdown>
        <BlockButtonClientCases lang={lang} body={body.rawMarkdownBody} />
      </ContentText>
    </Grid>
  );
};
export default BlockBook;
